import React from "react";
// import TotalMembers from "./TotalMembers";
import LastSales from "./LastSales";
import TrainerFeedbacks from "./TrainerFeedbacks";

const TLLcards = ({
  filters,
  sendableQPs,
  decryptedText,
  queryParametersForAll,
}) => {
  return (
    <div
      className={`erpCard tepl trainerDetailsCards lowSpace fiveGrid `}
    >
      {/* <TotalMembers
        sendableQPs={sendableQPs}
        queryParametersForAll={queryParametersForAll}
        decryptedText={decryptedText}
      /> */}
      <LastSales sendableQPs={sendableQPs} decryptedText={decryptedText} />

      <TrainerFeedbacks
        filters={filters}
        sendableQPs={sendableQPs}
        decryptedText={decryptedText}
        queryParametersForAll={queryParametersForAll}
        isFront={0}
      />
    </div>
  );
};

export default TLLcards;
